// Configuração da API do OpenWeather
export const WEATHER_API_KEY = '3e3e60f396cf9af3a3afda458480fc23'
export const WEATHER_API_URL = 'https://api.openweathermap.org/data/2.5/weather'
export const WEATHER_CITY = 'Limoeiro'
export const WEATHER_COUNTRY = 'BR'